import { CheckCircleFillIcon, AlertFillIcon } from '@primer/octicons-react';
import 'react';
import Text from '../../Text/Text.js';
import classes from './InputValidation.module.css.js';
import { clsx } from 'clsx';
import { jsxs, jsx } from 'react/jsx-runtime';

const validationIconMap = {
  success: CheckCircleFillIcon,
  error: AlertFillIcon
};
const InputValidation = ({
  children,
  className,
  id,
  validationStatus,
  sx
}) => {
  const IconComponent = validationStatus ? validationIconMap[validationStatus] : undefined;

  // TODO: use `text-caption-lineHeight` token as a custom property when it's available
  // then, we can move this all to CSS and use `calc` to get our height values
  const captionLineHeight = 16 / 12;
  const iconSize = 12;
  const iconBoxMinHeight = iconSize * captionLineHeight;
  return /*#__PURE__*/jsxs(Text, {
    className: clsx(className, classes.InputValidation),
    "data-validation-status": validationStatus,
    sx: sx,
    children: [IconComponent ? /*#__PURE__*/jsx("span", {
      "aria-hidden": "true",
      className: classes.ValidationIcon,
      style: {
        '--inputValidation-iconSize': iconBoxMinHeight
      },
      children: /*#__PURE__*/jsx(IconComponent, {
        size: iconSize,
        fill: "currentColor"
      })
    }) : null, /*#__PURE__*/jsx("span", {
      id: id,
      className: classes.ValidationText,
      style: {
        '--inputValidation-lineHeight': captionLineHeight
      },
      children: children
    })]
  });
};
InputValidation.displayName = "InputValidation";

export { InputValidation as default };
